import { render } from "./Control2Form.vue?vue&type=template&id=64e31ef5&scoped=true&ts=true&lang=pug"
import script from "./Control2Form.vue?vue&type=script&lang=ts"
export * from "./Control2Form.vue?vue&type=script&lang=ts"

import "./Control2Form.vue?vue&type=style&index=0&id=64e31ef5&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e31ef5"]])

export default __exports__